import { Plot } from '../../core/plot';
import { deepAssign } from '../../utils';

/**
 * ççå¾ é»è®¤éç½®é¡¹
 */
export const DEFAULT_OPTIONS = deepAssign({}, Plot.getDefaultOptions(), {
  interactions: [{ type: 'element-active' }],
  legend: false,
  tooltip: {
    showMarkers: false,
  },
  xAxis: {
    grid: null,
    tickLine: null,
    line: null,
  },
  maxAngle: 240,
});
